import React from 'react';
import { FiUser, FiUsers, FiBookOpen } from 'react-icons/fi';
import './AccountRoleSelector.css';

const roles = [
  { id: 'student', icon: FiUser, label: 'Student' },
  { id: 'teacher', icon: FiBookOpen, label: 'Teacher' },
  { id: 'parent', icon: FiUsers, label: 'Parent' },
];

function AccountRoleSelector({ selectedRole, onRoleChange }) {
  return (
    <div className="role-selector" role="radiogroup" aria-label="Account type">
      {roles.map(role => (
        <button
          key={role.id}
          type="button"
          className={`role-selector__tab ${selectedRole === role.id ? 'role-selector__tab--selected' : ''}`}
          onClick={() => onRoleChange(role.id)}
          role="radio"
          aria-checked={selectedRole === role.id}
        >
          <role.icon size={16} />
          <span>{role.label}</span>
        </button>
      ))}
    </div>
  );
}

export default AccountRoleSelector;
